export const css = {
    root: '-t2LyHbb',
    title: '_2E-DypGV',
    rect: '_2hjM6ubn',
    correct: '_33UCjyJ_',
    incorrect: '_3DGr5YFp',
    ' _key': 'quiz-widgets/correct'
};
export default css;
